export const REVIEWS = [
  {
    id: 1,
    review:
      "Now it 'is one year for my revision surgery of knee. She has improved a lot. Now she does the exercise suggested by hospital. After one year whenever we call hospital they give response and advise.",
    author: "S P Shukla",
  },
  {
    id: 2,
    review:
      "Overall experience right from the patient admission, operation & later discharge was very good. Staff was supportive and also doctors are caring & helpful.",
    author: "Tanvi Kulkarni",
  },
  {
    id: 3,
    review:
      "Admission process is smooth and easy. Nursing staff is very cooperative and friendly. Dr visits regularly after admission. Overall experience is good.",
    author: "Aman Sharma",
  },
  {
    id: 4,
    review:
      "Very quick action taken while admitting me in hospital. Good service received from each and every staff. Medicines are effective for fast recovery from my illness.",
    author: "Vaijayanti More",
  },
  // {
  //   id: 5,
  //   review:
  //     "Lokamanya has very good staff who understand the pain and support required by the patients. Accordingly, they guide the patients with complete concern, attention by providing the appropriate information to proceed with the process of consultation with the right Doctors at the right time. I was directed to consult Dr.Amit Kumar Pande who is MD-Medicines & MBBS, DM-Neurology. He has immense knowledge and vast experience in his field. The rootcauses of my issue was gently assessed and proper remedies were advised by him removing all panic thoughts coming out from me. This is what a patient expects out of Hospitals and Doctors instead of heavy cuts in your pockets and aggravated tensions without seeing any measures for the maladies. Lokamanya's nursing staff are excellent, empathetic and are very professional.",
  //   author: "Santosh Karunakar",
  // },
  // {
  //   id: 6,
  //   review:
  //     "I was diagnosed with avascular necrosis a year ago but hesitated to undergo surgery despite visiting several hospitals due to lack of satisfactory consultation. However, upon a relative's recommendation, I consulted with Suryavanshi sir, who provided thorough details about the surgery, including the implants to be used, instilling confidence in me. My interactions with Consultant Sujata Chavan were excellent; she efficiently managed the entire process from admission to discharge, explaining everything meticulously. Surgeon Ashish Suryavanshi and his team, including anesthesia specialist Dr. Amol and post-surgery care by Dr. Rishikesh, ensured my comfort and recovery. Deepali and Arti madam from the billing department were notably supportive. The nursing staff were also commendable in their assistance and politeness.",
  //   author: "Rajdatt Pawar",
  // },
  // {
  //   id: 7,
  //   review:
  //     "My mother was suffering from knee pain since many years. After surgery, the previous pain completely gone. She is very very comfortable now. Thank you so much Dr. N V Vaidya sir for your best surgery. Thank you so much to all staff of Lokmanya hospital. Special thanks to Jyoti madam, Rashmi for helping from OPD till discharge. Thanks to Smita, Jainy, Shiny, Annie sister for post-operative care.",
  //   author: "Amruta Masulkar",
  // },
  {
    id: 8,
    review:
      "I am admitted in male ward. Very good behavior from every staff. All staff, doctors, nurses, and other staff are very polite and calmly talking. Pharmacy, billing, floor staff, coordinator, physiotherapy all were cooperative. Thank you all, I will recommend this hospital to all.",
    author: "Santosh Tiwari",
  },
  // {
  //   id: 9,
  //   review:
  //     "One stop destination for all your orthopedic problems!! Great and very friendly staff. I was diagnosed with L4-L5 herniated disc and had to undergo immediate surgery. I was being treated by Dr. Pallav Bhatia, very understanding and good doctor. The surgery was successful and now I don't have any pain or complaints anymore. The staff and nurses are very helpful and understanding.",
  //   author: "Payal Ambhore",
  // },
  {
    id: 10,
    review:
      "Vaidya Sir is an expert in knee replacement, All Doctors, paramedical staff are very cooperative!",
    author: "Meenal Lad",
  },
  {
    id: 11,
    review:
      "Good place for treatment, overall very nice service of doctor and staff. Patient is treated with utmost care and attention. Nice service of billing department as well which supported for smooth claim processing.",
    author: "Amey Dalvi",
  },
  {
    id: 12,
    review:
      "Very helpful and supportive staff giving support during and after the surgery as well. Very happy with the overall experience. Dr. Vaidya is also very capable and handled the case very well. This hospital is highly recommended for one and all.",
    author: "Payal Shukla",
  },
  // {
  //   id: 13,
  //   review:
  //     "Hello Everyone, I was admitted on 21/06/23 here for an ACL & meniscus repair surgery. I was guided by Mrs. Sujata Patil Chavhan & Dr. Bhushan Ganveer (Arthroscopic). They have taken care of each and every scenario of what was I going through. How did the accident happen etc. I was glad that the operation was successful & I have started walking as well. I highly recommend this hospital for the service they have given and the way the treatment was done. Thank you, Lokmanya Hospital Nigdi.",
  //   author: "Jatin Jain",
  // },
  {
    id: 14,
    review:
      "Excellent service by all staff. Good management. Successfully operated, so he (father) can walk 2km per day without any complaint within one month and also drive two-wheelers and four-wheelers.",
    author: "Vedant Shinde",
  },
];

export const VIDEOS = [
  {
    id: 1,
    src: "./assets/img/youtube-img.webp",
    overlayText: "Lorem ipsum dolor sit amet consectetur, adipisicing elit.",
  },
  {
    id: 2,
    src: "./assets/img/youtube-img.webp",
    overlayText: "Lorem ipsum dolor sit amet consectetur, adipisicing elit.",
  },
  {
    id: 3,
    src: "./assets/img/youtube-img.webp",
    overlayText: "Lorem ipsum dolor sit amet consectetur, adipisicing elit.",
  },
  {
    id: 4,
    src: "./assets/img/youtube-img.webp",
    overlayText: "Lorem ipsum dolor sit amet consectetur, adipisicing elit.",
  },
  {
    id: 5,
    src: "./assets/img/youtube-img.webp",
    overlayText: "Lorem ipsum dolor sit amet consectetur, adipisicing elit.",
  },
  {
    id: 6,
    src: "./assets/img/youtube-img.webp",
    overlayText: "Lorem ipsum dolor sit amet consectetur, adipisicing elit.",
  },
  {
    id: 7,
    src: "./assets/img/youtube-img.webp",
    overlayText: "Lorem ipsum dolor sit amet consectetur, adipisicing elit.",
  },
];


export const hospitalCounterData = [
  { value: '50', label: 'History of Excellence' },
  { value: '500', label: 'Milestone Achievements' },
  { value: '10000', label: 'Countless Smiles Delivered' },
  { value: '30', label: 'Pioneers in Healthcare' },
];
export const narendraCounterData = [
  { value: '50', label: 'Years of Experience' },
  { value: '500', label: 'Successful Surgeries' },
  { value: '10000', label: 'Happy Patients' },
  { value: '30', label: 'Expert Specialists' },
];


